export const resources = {
  MyCloud: '',
  Hidden: '',
  ViewAllCameras: '',
  EdgeExtensionsPageTitle: '',
  Loading: ''
};
